import React from "react";
import styled, { ThemeProvider } from "styled-components";
import { shade, rgba } from "polished";
import theme from "../theme.js";
import { Box, Flex } from "rebass";
import { H3, H4, OverlayImage } from "components";
import moment from "moment";

const Action = styled(Box)`
  text-decoration: none;
  cursor: pointer;
  opacity: 0;
  animation: update-card-fade-in 1s cubic-bezier(0.23, 1, 0.32, 1) forwards;
  will-change: opacity;

  @keyframes update-card-fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  &:hover {
    .update-card__tile {
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
      transform: translateY(-4px);
    }
    .update-card__title {
      box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.grey[0]};
    }
  }
  &:active {
    .update-card__tile {
      box-shadow: none;
      transform: translateY(-2px);
    }
    .update-card__title {
      box-shadow: inset 0 -1px 0 ${(props) => props.theme.colors.grey[1]};
    }
  }

  * {
    text-decoration: none;

    &::selection {
      color: ${(props) => props.theme.colors.grey[2]};
      background-color: ${(props) =>
        props.theme.colors[props.cardColor] &&
        shade(0.9375, props.theme.colors[props.cardColor])};
    }
  }
`;

Action.defaultProps = {
  is: "a",
};

const ImageWrapper = styled(Box)`
  position: relative;
  width: 100%;
  padding-bottom: ${(2 / 3) * 100 + "%"};
  /* background-color: ${(props) => props.theme.colors[props.cardColor]};
  background-color: ${(props) => props.theme.colors.grey[1]}; */
  transition: transform 500ms cubic-bezier(0.23, 1, 0.32, 1),
    box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
  will-change: transform;
  user-select: none;
  &:not(:lang(ar)) {
    &:before,
    &:after {
      right: 0;
    }
    &:after {
      background: ${(props) =>
        props.noColor
          ? ""
          : props.theme.colors.grey[1] &&
            "linear-gradient(to right, " +
              rgba(props.theme.colors.grey[1], 0.75) +
              ", " +
              rgba(props.theme.colors.grey[1], 0) +
              ")"};
    }
  }
  &:lang(ar) {
    &:before,
    &:after {
      left: 0;
    }
    &:after {
      background: ${(props) =>
        props.noColor
          ? ""
          : props.theme.colors.grey[1] &&
            "linear-gradient(to left, " +
              rgba(props.theme.colors.grey[1], 0.75) +
              ", " +
              rgba(props.theme.colors.grey[1], 0) +
              ")"};
    }
  }
`;

const Title = styled(H3)`
  margin-top: 8px;
  padding-bottom: 8px;
  font-size: 18px;

  > span {
    box-shadow: inset 0 -1px 0 transparent;
    transition: box-shadow 500ms cubic-bezier(0.23, 1, 0.32, 1);
    will-change: box-shadow;
  }
`;

const Metadata = styled(H4)``;

const truncateText = (text) => {
  if (text.length > 65) {
    let textArray = text.split(" ");
    let textBuildup = "";
    let position = 0;
    while (textBuildup.length < 65) {
      textBuildup += textArray[position] + " ";
      position++;
    }
    if (
      textBuildup[textBuildup.length - 2] !== "?" &&
      textBuildup[textBuildup.length - 2] !== "!" &&
      textBuildup[textBuildup.length - 2] !== "."
    ) {
      text = textBuildup.slice(0, textBuildup.length - 1) + "...";
    }
  }
  return text;
};

const ExternalUpdateCard = (props) => {
  if (
    props.title &&
    props.link &&
    props.date &&
    props.image &&
    props.image.url
  ) {
    return (
      <ThemeProvider theme={theme}>
        <Action
          href={props.link}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={props.title[0] ? props.title[0].text : ""}
        >
          <ImageWrapper className="update-card__tile">
            <OverlayImage
              imageColor="grey.2"
              backgroundImage={
                props.image
                  ? [
                      props.image.url,
                      props.image.half ? props.image.half.url : "",
                      props.image.quarter ? props.image.quarter.url : "",
                    ]
                  : undefined
              }
            />
          </ImageWrapper>
          <Title>
            <span
              className="update-card__title"
              children={props.title[0] ? truncateText(props.title[0].text) : ""}
            />
          </Title>
          <Flex>
            <Metadata mt={"3px"} mr={3}>
              {props.date ? moment(props.date).format("MMMM DD, YYYY") : ""}
            </Metadata>
          </Flex>
        </Action>
      </ThemeProvider>
    );
  } else {
    return null;
  }
};

export default ExternalUpdateCard;



// WEBPACK FOOTER //
// ./src/components/ExternalUpdateCard.js